import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import DocumentForm from "components/form/DocumentForm";

import { SaveContextProvider } from "context/save";

import useDocumentForm from "hooks/form/useDocumentForm";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Documento modificato con successo",
        errorMsg: "Errore nella modifica del documento",
        navigateTo: { link: "/cm-documenti" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function ModificaDocumentoInner() {
    const formDocumentHook = useDocumentForm();

    return (
        <>
            <DocumentForm formDocumentHook={formDocumentHook} />
            <ButtonSave />
        </>
    );
}

function ModificaDocumento() {
    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Documento</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ModificaDocumentoInner />
            </SaveContextProvider>
        </>
    );
}

export default ModificaDocumento;
